<template>
  <transition
    name="local-fade"
    appear
    mode="out-in"
  >
    <router-view />
  </transition>
</template>
